





















import { Vue, Component, Prop } from 'vue-property-decorator'
import CircularProgress from '@/modules/shared/components/CircularProgress'

@Component({
  components: {
    CircularProgress
  }
})
export default class RegistrationProgress extends Vue {
  @Prop({ required: true }) denominator!: number
  @Prop({ required: true }) numerator!: number
  @Prop({ default: 90 }) rotate!: number
  @Prop({ default: 100 }) size!: number
  @Prop({ default: undefined }) iconSize!: number
  @Prop({ default: 5 }) width!: number
  @Prop({ type: Boolean, default: false }) hideProgress!: boolean
  @Prop({ type: Boolean, default: false }) autoSize!: boolean
  @Prop({ type: Boolean, default: false }) loading!: boolean

  /* Computed Properties */
  get value() {
    return (this.numerator / this.denominator) * 100
  }
}
